import { createHdmiInputHandler } from '../../../MediaController';
import { BrightSignHdmiInputHandler } from '../../../MediaController/Video';
import { MediaControllerController } from './MediaControllerController';

export class VideoCaptureController extends MediaControllerController {
    type: string;

    constructor(wrapperElement: HTMLDivElement) {
        const handler = createHdmiInputHandler({ continuousPlayback: true, muted: false });
        super(wrapperElement, handler);

        if (handler instanceof BrightSignHdmiInputHandler) {
            this.type = 'BRIGHTSIGN_HDMI';
        } else {
            this.type = 'VLC_VIDEO_CAPTURE';
        }
    }
}
